import { render } from "./ZettFormDialog.vue?vue&type=template&id=a56847cc&scoped=true"
import script from "./ZettFormDialog.vue?vue&type=script&lang=js"
export * from "./ZettFormDialog.vue?vue&type=script&lang=js"

import "./ZettFormDialog.vue?vue&type=style&index=0&id=a56847cc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56847cc"]])

export default __exports__